import swal from 'sweetalert2'

import { DashboardModuleListItem } from '@domain-group/suit-theme'
import { digObject } from '@domain-group/javascript-utils'

import { templatePageTypes } from '@functions/relatedEntity'

import { RelatedEntityModel, TemplatePageModel } from '@models/types'

import useRelatedEntity from '@hooks/useRelatedEntity'

// @ts-expect-error TS7006
const confirmDelete = (deleteRelatedEntity, deleteFn) => {
  const deleteRelatedEntityPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Connection Deleted',
  }

  swal
    .fire({
      title: 'Delete Connection?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        deleteRelatedEntity(deleteRelatedEntityPayload)
      }
    })
}

interface TemplatePageProps {
  callbacks: {
    deleteRelatedEntity: () => void,
  },
  relatedEntity: RelatedEntityModel,
  templatePage: TemplatePageModel,
}

const TemplatePage = (props: TemplatePageProps) => {
  const {
    callbacks: {
      deleteRelatedEntity,
    },
    relatedEntity,
    templatePage,
  } = props

  const relatedEntityPayload = useRelatedEntity(relatedEntity)
  const {
    callbacks: {
      createOrEditRelatedEntity,
      deleteRelatedEntity: deleteFn,
    },
    relatedEntity: {
      subject_id,
    },
  } = relatedEntityPayload

  const templateTypeKey = digObject(relatedEntity, 'data.template_type', 'new')
  // @ts-expect-error TS7053
  const templateTypeLabel = templatePageTypes[templateTypeKey] || 'New'

  return (
    <DashboardModuleListItem
      secondaryText={`${templateTypeLabel} Template Page`}
      title={`${templatePage.title} - #${subject_id}`}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon marginRight="medium" onClick={() => createOrEditRelatedEntity()} type="edit" />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteRelatedEntity, deleteFn)}
          type="delete"
        />

        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon type="link" />
      {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default TemplatePage
